import { Button } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import {
  toggleLoomDownloadModal,
  toggleRecordToNonDefaultWorkspaceModal,
} from 'actions/videosDashboard';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from 'constants/events';
import { RECORD_VIDEO_CARD_KEY } from 'constants/workspaceOnboarding';
import { PRIVATE_WORKSPACE } from 'constants/workspaces';
import * as analytics from 'utilities/analytics';
import { requestExtensionOpenIfInstalled } from 'utilities/extension';

import {
  useGetDefaultWorkspace,
  useGetSelectedWorkspace,
  useGetUserRoleForSelectedWorkspace,
} from 'hooks/workspace';

import DashboardOnboardingCard from '../..';

import { VideoSvg } from 'components/videos-dashboard-ta/empty-library-ta/icons';

export const filterFunction = (
  library,
  isAdmin,
  libraryVideoCounts,
  isExistingUser
) => {
  if (isExistingUser && !isAdmin) {
    const personalVideoExists = libraryVideoCounts[PRIVATE_WORKSPACE] === 0;

    return personalVideoExists;
  }

  return true;
};

const RecordVideoCard = ({ cardConfig }) => {
  const selectedWorkspace = useGetSelectedWorkspace();
  const defaultWorkspace = useGetDefaultWorkspace();
  const userRole = useGetUserRoleForSelectedWorkspace();
  const dispatch = useDispatch();

  if (!userRole) {
    return null;
  }

  const header = 'Record your first video';
  const description = 'Get started by creating your first video.';
  const isDefaultWorkspace = selectedWorkspace?.id === defaultWorkspace?.id;

  const primaryActionClickHandler = isDefaultWorkspace
    ? () => {
        requestExtensionOpenIfInstalled(
          'dashboard-onboarding-card',
          success => {
            if (!success) {
              dispatch(toggleLoomDownloadModal(true));
            }
          }
        );
      }
    : () => dispatch(toggleRecordToNonDefaultWorkspaceModal(true));

  const onPrimaryAction = () => {
    primaryActionClickHandler();

    analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
      type: 'primary',
      card: RECORD_VIDEO_CARD_KEY,
    });
  };

  const primaryAction = (
    <Button variant="record" onClick={onPrimaryAction}>
      Start recording
    </Button>
  );

  const centerpiece = <VideoSvg />;

  return (
    <>
      <DashboardOnboardingCard
        cardKey={RECORD_VIDEO_CARD_KEY}
        cardConfig={cardConfig}
        heading={header}
        description={description}
        centerpiece={centerpiece}
        primaryAction={primaryAction}
      />
    </>
  );
};

export default RecordVideoCard;
